import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import lazyload, {
    execute
} from './features/lazy-load';

import {
    TabsPlugin
} from 'bootstrap-vue';

lazyload();

const mixins = [];

mixins.push({
    methods: {
        onJournalistSearch: function (value) {
            this.activeJournalistsSearch = value;
            if (!this.activeJournalistsSearch) {
                this.$nextTick(() => execute());
            }
        }
    },
    data: function () {
        return {
            activeJournalistsSearch: false,
        };
    }
});

initMain(mixins, {
    JournalistsAc: () => import('./vue/components/journalists-ac/JournalistsAc.vue'),
    JournalistsSearch: () => import('./vue/components/journalists-search/JournalistsSearch.vue'),
    JournalistsLatest: () => import('./vue/components/journalists-Latest/JournalistsLatest.vue'),
    JournalistsByName: () => import('./vue/components/journalists-by-name/JournalistsByName.vue'),
}, [
    TabsPlugin
]);

header();